import React from 'react';
import './Button.css';

/**
 * Button Component
 *
 * @param {string} variant - primary | secondary | outline | ghost | danger
 * @param {string} size - sm | md | lg
 * @param {boolean} disabled - Disabled state
 * @param {boolean} loading - Loading state (shows spinner)
 * @param {boolean} fullWidth - Full width button
 * @param {string} className - Additional classes
 * @param {node} children - Button content
 * @param {node} icon - Icon element
 */
function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  fullWidth = false,
  className = '',
  children,
  icon,
  ...props
}) {
  const classes = [
    'ui-button',
    `ui-button--${variant}`,
    `ui-button--${size}`,
    fullWidth && 'ui-button--full-width',
    loading && 'ui-button--loading',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span className="ui-button__spinner">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="30" strokeDashoffset="30">
              <animateTransform attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="0.8s" repeatCount="indefinite" />
            </circle>
          </svg>
        </span>
      )}
      {icon && <span className="ui-button__icon">{icon}</span>}
      <span className="ui-button__content">{children}</span>
    </button>
  );
}

export default Button;
